export default __webpack_public_path__ + "static/media/iconoLink.f4513004.svg";